import { useMemo } from "react";

import useTranslations from "@/shared/lang/useTranslations";

import type { LedgerOperationType } from "../types/payments-wallets.types";

/** Translated labels for each ledger `operation_type`, memoized per language. */
export const useOperationLabels = (): Record<LedgerOperationType, string> => {
  const { t } = useTranslations("wallets");
  return useMemo(
    () => ({
      PAYIN: t("tx_op_payin"),
      PAYOUT: t("tx_op_payout"),
      SWAP: t("tx_op_swap"),
      FEE: t("tx_op_fee"),
      ADJUST: t("tx_op_adjust"),
      REVERSE: t("tx_op_reverse"),
    }),
    [t],
  );
};
